import { register } from "register-service-worker";
import store from "@/store";

const appVersion = process.env.VUE_APP_VERSION;
const isPrivate = process.env.VUE_APP_MODE === "private";

if (appVersion) {
  console.log("app version", appVersion);
}

if (isPrivate && location.origin.startsWith("https://")) {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready(registration) {
      console.log(
        "App is being served from cache by a service worker.\n" +
          "For more details, visit https://goo.gl/AFskqB"
      );
      store.commit("SET_SERVICE_WORKER_REGISTRATION", registration);
    },
    registered() {
      console.log("Service worker has been registered.");
    },
    cached() {
      console.log("Content has been cached for offline use.");
    },
    updatefound() {
      console.log("New content is downloading.");
    },
    async updated() {
      console.log("New content is available; please refresh.");
      await store.dispatch("REFRESH_SERVICE_WORKER_REGISTRATION");
      setTimeout(() => {
        if (
          window.location.hash.includes("#/") ||
          window.location.hash.includes("#/mobile")
        ) {
          window.location.reload(true);
        }
      }, 500);
    },
    offline() {
      console.log(
        "No internet connection found. App is running in offline mode."
      );
    },
    error(error) {
      console.error("Error during service worker registration:", error);
    }
  });
}
